import React from 'react';

import { classNames } from '../../utils/css';

import { useMobileMenuContext } from './mobileMenuContext';

const MobileMenuLink = ({
  title,
  path,
  classname,
}) => {
  const { toggleOpen } = useMobileMenuContext();

  return (
    <a
      href={path}
      className={classNames(
        "mobile_menu__tab__panel__item__link",
        classname,
      )}
      onClick={() => toggleOpen(false)}
    >
      {title}
    </a>
  );
};

export default MobileMenuLink;
